import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Aboutus } from "./components/Aboutus";

import ProjectDetail from "./components/ProjectDetail"

function Home() {
  return (
    <>
      <NavBar />
      <Banner />
      <Aboutus />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Landing Page */}
        <Route path="/" element={<Home />} />

        {/* Project Detail Page */}
        <Route path="/project/:slug" element={<ProjectDetail />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;